import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_frju6wwynd: FaireBrandEntity = {
  token: "b_frju6wwynd",
  type: "brand",
  name: "Carried Away Bath",
  avatarUrl:
    "https://cdn.faire.com/fastly/7f2bfb8085fa88b4dcb588381bf4d10266d51be16422483fc350528a58046c32.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9e5ea8d5b30681fcb75db5636566143be200f9db9b3303c046dc5d9dd9d715dc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7f2bfb8085fa88b4dcb588381bf4d10266d51be16422483fc350528a58046c32.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9e5ea8d5b30681fcb75db5636566143be200f9db9b3303c046dc5d9dd9d715dc.png",
  location: "Kindred, ND, USA",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 47,
  isTopShop: true,
  isInsider: true,
  description:
    "🚨 The current processing time is 11-14 business days.  Thank you for supporting handmade – and for your patience while I pack orders with love (and coffee!).\n\nHi, I’m Tara — the hands, heart, and slightly over-caffeinated brain behind Carried Away Bath. I create handmade soaps, body products, and wax melts in small batches right from my soap studio. Every item is poured, stirred, swirled, or labeled by me (with maybe a little sparkle thrown in). I believe in fun, functional self-care and making products that bring joy to your skin and your day.\n\nCarried Away Bath is made to stand out on your shelves — colorful, gift-ready, and crafted with care. Whether you’re looking for everyday staples or seasonal showstoppers, I’m here to make wholesale feel personal and easy.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.629Z",
    importedBy: "entity-db-cli",
  },
};
